import { ItemType } from './ItemType';

// Following types use extended fund details (name, address, phone number)
// If a toolkit type is not present here it just has the fund name as part of it's fund details spec
export const FundDetails = [
  ItemType.PENSION_ESTABLISHMENT,
];

export default FundDetails;
